import * as Sentry from '@sentry/react';
const tokenEl = document.getElementById('sentry-token');
if (tokenEl) {
  Sentry.init({
    dsn: tokenEl.content,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0
  });
}
